import type {
  ResolutionInputTypeComboboxOptions,
  ResolutionInputTypeMapping,
  ResolutionSetup,
  ResolutionTypeComboboxOptions
} from '@library/types/resolutions/resolutionDetails';

export const resolutionInputTypeMapping: ResolutionInputTypeMapping = {
  dnp: ['projection'],
  mass_win: ['projection'],
  refund: ['new_wager', 'projection']
};

export const resolutionTypeOptions: ResolutionTypeComboboxOptions = [
  {
    label: 'DNP',
    value: 'dnp'
  },
  {
    label: 'Mass Win',
    value: 'mass_win'
  },
  {
    label: 'Refund',
    value: 'refund'
  }
];

export const resolutionInputTypeOptions: ResolutionInputTypeComboboxOptions = [
  {
    label: 'New Wager Id',
    value: 'new_wager'
  },
  {
    label: 'Projection ID',
    value: 'projection'
  }
];

export const defaultResolutionSetup: ResolutionSetup = {
  resolutionInputType: 'new_wager',
  resolutionType: 'refund'
};

export const FETCH_FAILURES_PER_PAGE_COUNT = 10;

export const FETCH_ALL_RESOLUTIONS_PER_PAGE_COUNT = 50;
